<tt-list *ngIf="!loading" [(ttData)]="orderheads"></tt-list>
<ng-container *ngIf="loading">
    <ng-container *ngFor="let item of pageSizeArray" [ngTemplateOutlet]="skeleton"></ng-container>
</ng-container>
<tt-pager
    ttPersistLocalOnly="true"
    ttRememberId="w_orderheads.list.pagination"
    [(ttPageIndex)]="page"
    [(ttPageSize)]="pageSize"
    [ttTotalCount]="total"
    (ttPageChange)="loadOrderHeads()"
    (ttPageIndexChange)="loadOrderHeads()"
></tt-pager>
<ng-template #skeleton>
    <div class="col-xs-12 sp-0 tt-skeleton tt-list-item" style="height: 4.5rem"></div>
</ng-template>
